
import Breadcrumbs from '~/components/UI/Breadcrumbs.vue';
import Filters from '~/components/filters/Filters.vue';
import SetsMixin from '~/node_modules/sitis-nuxt/lib/mixins/SetsMixin';

export default {

  asyncData: async function ({ $api, route }) {
    // место истины в imagesCategory()
    const slug = String(String(String(route?.params.pathMatch || '').split('/f/')?.[0] || '').split('?')?.[0] || '')?.split('#')?.[0] || '';

    if (slug === 'kvartiry-s-remontom') { // специально обнуляю, дальше в computed imagesCategory()
      return {
        imagesFromProducts: []
      };
    }

    const imagesFromProducts = await $api.agent.transport.get(`/filter-pages/${ slug }/products?filter[group_planing_product][]=da`)
      .then(res => (res?.data || []).map(t => t.image_id))
      .catch(() => []);

    return {
      imagesFromProducts
    };
  },

  components: {
        Breadcrumbs,
        Filters,

        MessageImage: () => import('~/components/sets-page/MessageImage.vue'),
        ContentProducts: () => import('~/components/sets-page/ContentProducts.vue'),
        ContentProductsMobile: () => import('~/components/sets-page/ContentProductsMobile.vue'),
    },

    mixins: [
        SetsMixin,
    ],

    data() {
      return {
        tableOptions: [
          {
            label: '№ кв стр',
            fieldName: 'name',
          },
          {
            label: 'Этаж',
            charName: 'etaz',
            sort: 'etaz',
          },
          {
            label: 'Этажность',
            charName: 'etaznost',
            sort: 'etaznost',
          },
          {
            label: 'Общая площадь',
            charName: 'plosad',
            sort: 'plosad',
          },
          {
            label: 'Цена за кв.м.',
            charName: 'cena-za-m',
            type: 'number',
            sort: 'cena-za-m',
          },
          {
            label: 'Статус',
            charName: 'status',
            sort: 'status',
          },
          {
            label: 'Стоимость',
            fieldName: 'price',
            type: 'number',
            sort: 'price',
          },
          {
            label: '',
            fieldName: 'imageId',
            type: 'image',
          },
        ],
        timeOutUpdateProducts: null,
      };
    },

    head() {
        let title = this.category?.seo?.title || this.category?.metaTitle || this.category?.title || '';
        if (this.pagination.page > 1) {
          title = [title, ` - Страница №${ this.pagination.page }`].join('');
        }

        const head = {
            title,
            meta: [],
        };

        if (title) {
            head.meta.push({
                name: 'og:title', hid: 'og:title', property: 'og:title', content: title,
            });
        }

        let description = this.category?.seo?.description || this.category?.metaDescription || this.category?.description || '';
        if (description && this.pagination.page > 1) {
          description = [description, ` - Страница №${ this.pagination.page }`].join('')
        }
        if (description) {
            head.meta.push({ hid: 'metadescription', name: 'description', content: description });
            head.meta.push({
                name: 'og:description', hid: 'og:description', property: 'og:description', content: description,
            });
        }
        return head;
    },

    computed: {
        breadcrumbs() {
            return [
                { path: '/', title: 'Главная' },
                { path: this.$route.path, title: this.pageTitle },
            ];
        },

        pageTitle() {
            return this.category?.title || '';
        },
        labelCountFree() {
            const count = Number.parseFloat(this.total);
            const word = this.$caseWords(count, [
                'квартира', 'квартиры', 'квартир',
            ]);

            return [count, word].join(' ');
        },

        isLoadProducts() {
            const loadingState = this.$store.state.appState.loading || {};
            return Boolean(loadingState?.category || loadingState.products);
        },

        extensions() {
            return ['short_characteristics'];
        },
        defaultSort() {
            return 'etaz';
        },

        imagesCategory() {
            if (this.routerParams?.slug === 'kvartiry-s-remontom') {
                return (this.category?.dynamicFields?.additional_images || [])
                    .map(t => t.image);
            }

            return this.imagesFromProducts || [];
        },
    },

    methods: {
        openCallBack(product) {
            const message = `Заявка на бронирование ${this.pageTitle} "${product.name}"`;
            const additional_data = {
                macro_id: parseInt((product?.code || '').match(/\d+/)),
            };

            const rooms = (product?.shortCharacteristics || []).find((t) => t.slug === 'rooms')?.values?.[0]?.slug;
            let reachGoal = 'bronirovanie';
            if (rooms === 'studiya') {
                reachGoal = 'bronirovanie_studia';
            }
            if (rooms === '1') {
                reachGoal = 'bronirovanie_1k';
            }
            if (rooms === '2') {
                reachGoal = 'bronirovanie_2k';
            }
            if (rooms === '3') {
                reachGoal = 'bronirovanie_3k';
            }

            this.$store.commit('back-call/setOpen', {
                open: true,
                settings: {
                    title: `Бронирование ${this.pageTitle}`,
                    formType: 'Бронирование квартиры',
                    message,
                    additional_data,

                    reachGoal,
                },
            });
        },
        clickRow(product) {
            this.$router.push(product.url);
        },
      async onRequestUpdateFilter(filters) {
        clearTimeout(this.timeOutUpdateProducts);
        this.timeOutUpdateProducts = setTimeout(async () => {
          await this.getUpdateFilters(filters);
          await this.onRequestUpdateProducts(filters);
        }, 500);
      },
      async onRequestUpdateProducts (filters) {
        // await this.handleUpdateFiltersQuery(filters)
        await this.updateFiltersQuery(filters)
        await this.searchProducts(filters)
      },
      handleClearFilters: function () {
        this.clearFilters();
      },
    },
};
